export default __webpack_public_path__ + "static/leaves-b12939affdf244fb1f4d0dc6b9564f86.png";